"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _PanelPropertiesInfoSelector = require("./PanelPropertiesInfoSelector.css");

var _PanelPropertiesInfoSelector2 = _interopRequireDefault(_PanelPropertiesInfoSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

//     

var PanelPropertiesInfoSelector = function (_Component) {
	_inherits(PanelPropertiesInfoSelector, _Component);

	function PanelPropertiesInfoSelector() {
		_classCallCheck(this, PanelPropertiesInfoSelector);

		var _this = _possibleConstructorReturn(this, (PanelPropertiesInfoSelector.__proto__ || Object.getPrototypeOf(PanelPropertiesInfoSelector)).call(this));

		_this.toggleVisibilityEditPanel = function () {
			return _this.setState({ visibleEditPanel: !_this.state.visibleEditPanel });
		};

		_this.state = {
			visibleEditPanel: true
		};
		return _this;
	}

	_createClass(PanelPropertiesInfoSelector, [{
		key: "renderHeaderFields",


		/* 	onChangeToogle(id, checked) {
  		this.props.updateSelectedfieldsLabels(id, checked);
  	} */

		value: function renderHeaderFields(pos, tag, colorPanellTextCurrent) {
			var _this2 = this;

			var selected = this.props.calcdatafields;
			var alias = this.props.selectedfieldsLabels;
			var itemH = [];

			selected.map(function (itemHeader, index) {
				return itemH.push(_react2.default.createElement(
					_semanticUiReact.List.Item,
					null,
					_react2.default.createElement(
						_semanticUiReact.List.Content,
						null,
						_react2.default.createElement(_semanticUiReact.Input, { size: "mini",
							id: index,
							key: itemHeader,
							onChange: function onChange(e, data) {
								return _this2.props.updateSelectedfieldsLabels(itemHeader, data.value);
							},
							value: alias[itemHeader] }),
						_react2.default.createElement(
							_semanticUiReact.Label,
							{ size: "mini", style: { color: colorPanellTextCurrent }, className: _PanelPropertiesInfoSelector2.default.label },
							itemHeader
						)
					)
				));
			});

			return itemH;
		}
	}, {
		key: "render",
		value: function render() {
			var visibleEditPanel = this.state.visibleEditPanel;
			var colorPanell = this.props.colorPanell;
			var colorPanellText = this.props.colorPanellText;


			var colorPanellCurrent = "rgba(" + colorPanell.r + ", " + colorPanell.g + ", " + colorPanell.b + ", " + colorPanell.a + ")";
			var colorPanellTextCurrent = "rgba(" + colorPanellText.r + ", " + colorPanellText.g + ", " + colorPanellText.b + ", " + colorPanellText.a + ")";

			return _react2.default.createElement(
				"div",
				{ className: _PanelPropertiesInfoSelector2.default.panelInfo, id: "panelInfo" },
				_react2.default.createElement(
					_semanticUiReact.Segment,
					{ style: { backgroundColor: colorPanellCurrent, color: colorPanellTextCurrent } },
					_react2.default.createElement(
						"h5",
						null,
						"Noms camps informaci\xF3  ",
						_react2.default.createElement(_semanticUiReact.Icon, { content: visibleEditPanel ? "Hide" : "Show", onClick: this.toggleVisibilityEditPanel, style: { backgroundColor: colorPanellCurrent, color: colorPanellTextCurrent }, link: true, size: "large", name: "caret down" })
					),
					_react2.default.createElement(
						_semanticUiReact.Transition,
						{ visible: visibleEditPanel, animation: "scale", duration: 500 },
						_react2.default.createElement(
							_semanticUiReact.List,
							{ size: "tiny" },
							this.renderHeaderFields(0, "header", colorPanellTextCurrent)
						)
					)
				)
			);
		}
	}]);

	return PanelPropertiesInfoSelector;
}(_react.Component);

exports.default = PanelPropertiesInfoSelector;


PanelPropertiesInfoSelector.propTypes = {
	modeEdicio: _propTypes2.default.bool,
	selectedfields: _propTypes2.default.array,
	showPanelPropertiesInfoSelector: _propTypes2.default.bool,
	colorPanell: _propTypes2.default.object,
	colorPanellText: _propTypes2.default.object,
	selectedfieldsLabels: _propTypes2.default.object,
	calcdatafields: _propTypes2.default.array,
	updateSelectedfieldsLabels: _propTypes2.default.func
};
